                import { Divider, Stack, Typography, TextField, InputAdornment, IconButton, Avatar, List, ListItem, ListItemAvatar, ListItemText, Button } from "@mui/material";
                import SearchIcon from '@mui/icons-material/Search';
                import AddIcon from '@mui/icons-material/Add';
                import MessageIcon from '@mui/icons-material/Message';
                import MessagesProfileComponent from "./MessagesProfileComponent";
                import { useState, useEffect } from "react";
                import api from "../../config/axios";

                function MessagesSection() {
                  const [chats, setChats] = useState([]);
                  const [searchQuery, setSearchQuery] = useState('');
                  const [filteredChats, setFilteredChats] = useState([]);
                  const [selectedChat, setSelectedChat] = useState(null);
                  const [isActive, setIsActive] = useState(0);
                  const [loading, setLoading] = useState(true);
                  const [users, setUsers] = useState([]);
                  const [friends, setFriends] = useState([]);
                  const [showSearchResults, setShowSearchResults] = useState(false);
                  const [currentUser, setCurrentUser] = useState(null);

                  useEffect(() => {
                    fetchInitialData();
                  }, []);

                  const fetchInitialData = async () => {
                    try {
                      setLoading(true);
                      // Get all users
                      const usersResponse = await api.get('/auth/users');
                      setUsers(usersResponse.data);
                      setCurrentUser(usersResponse.data.find(u => u._id === JSON.parse(localStorage.getItem('user'))._id));

                      // Get friends
                      const friendsResponse = await api.get('/friends');
                      setFriends(friendsResponse.data);

                      // Get all chats
                      const chatsResponse = await api.get('/chat');
                      console.log('Current user ID:', JSON.parse(localStorage.getItem('user'))._id);
                      console.log('Raw chat data:', chatsResponse.data);
                      
                      const formattedChats = chatsResponse.data.map(chat => {
                        const otherParticipant = chat.participants.find(
                          p => p._id !== JSON.parse(localStorage.getItem('user'))._id
                        );
                        
                        const currentUserId = JSON.parse(localStorage.getItem('user'))._id;
                        console.log('Processing chat:', chat._id);
                        console.log('Current user ID:', currentUserId);
                        
                        return {
                          id: chat._id,
                          user: {
                            id: otherParticipant._id,
                            name: `${otherParticipant.firstName} ${otherParticipant.lastName}`,
                            avatar: otherParticipant.profileImage || "/images/default-avatar.jpeg",
                            lastMessage: chat.lastMessage?.text || "Start a conversation",
                            lastMessageTime: chat.lastMessage?.timestamp 
                              ? new Date(chat.lastMessage.timestamp).toLocaleDateString()
                              : new Date().toLocaleDateString(),
                            messages: chat.messages.map(msg => {
                              const isSentByMe = msg.sender === currentUserId || msg.sender._id === currentUserId;
                              console.log('Message:', {
                                messageId: msg._id,
                                senderId: msg.sender._id || msg.sender,
                                currentUserId: currentUserId,
                                isSentByMe: isSentByMe
                              });
                              return {
                                id: msg._id,
                                text: msg.text,
                                time: new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                                sender: isSentByMe ? 'me' : otherParticipant._id,
                                isReply: !isSentByMe
                              };
                            })
                          }
                        };
                      });

                      console.log('Formatted chats:', formattedChats);
                      setChats(formattedChats);
                      setFilteredChats(formattedChats);
                    } catch (error) {
                      console.error('Error fetching data:', error);
                    } finally {
                      setLoading(false);
                    }
                  };

                  // Filter users and chats based on search query
                  useEffect(() => {
                    if (searchQuery) {
                      setShowSearchResults(true);
                      // Filter chats
                      const filtered = chats.filter(chat => 
                        chat.user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        chat.user.lastMessage.toLowerCase().includes(searchQuery.toLowerCase())
                      );
                      setFilteredChats(filtered);
                    } else {
                      setShowSearchResults(false);
                      setFilteredChats(chats);
                    }
                  }, [searchQuery, chats]);

                  const handleStartChat = async (userId) => {
                    try {
                      const response = await api.post('/chat/start', { userId });
                      const chat = response.data;
                      
                      const otherParticipant = chat.participants.find(
                        p => p._id !== JSON.parse(localStorage.getItem('user'))._id
                      );

                      const formattedChat = {
                        id: chat._id,
                        user: {
                          id: otherParticipant._id,
                          name: `${otherParticipant.firstName} ${otherParticipant.lastName}`,
                          avatar: otherParticipant.profileImage || "/images/default-avatar.jpeg",
                          lastMessage: chat.lastMessage?.text || "Start a conversation",
                          lastMessageTime: chat.lastMessage?.timestamp 
                            ? new Date(chat.lastMessage.timestamp).toLocaleDateString()
                            : new Date().toLocaleDateString(),
                          messages: chat.messages.map(msg => {
                            // Check if the message is from the current user
                            const isSentByMe = msg.sender._id === JSON.parse(localStorage.getItem('user'))._id;
                            return {
                              id: msg._id,
                              text: msg.text,
                              time: new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                              sender: isSentByMe ? 'me' : otherParticipant._id,
                              isReply: !isSentByMe
                            };
                          })
                        }
                      };

                      // Add new chat to the list if it doesn't exist
                      setChats(prevChats => {
                        const exists = prevChats.some(c => c.id === chat._id);
                        if (!exists) {
                          return [formattedChat, ...prevChats];
                        }
                        return prevChats;
                      });

                      // Select the chat
                      setSelectedChat(formattedChat);
                      setIsActive(0);
                      
                      // Update filtered chats
                      setFilteredChats(prevFiltered => {
                        const withoutExisting = prevFiltered.filter(c => c.id !== chat._id);
                        return [formattedChat, ...withoutExisting];
                      });

                      // Clear search
                      setShowSearchResults(false);
                      setSearchQuery('');

                    } catch (error) {
                      console.error('Error starting chat:', error);
                      alert('Failed to start chat. Please try again.');
                    }
                  };

                  const handleSendMessage = async (chatId, message) => {
                    try {
                      const response = await api.post(`/chat/${chatId}/messages`, { text: message });
                      const sentMessage = response.data;
                      console.log('Sent message response:', sentMessage);

                      const newMessage = {
                        id: sentMessage._id,
                        text: sentMessage.text,
                        time: new Date(sentMessage.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                        sender: 'me', // Always 'me' for messages we send
                        isReply: false
                      };

                      console.log('New message formatted:', newMessage);

                      // Update chats state
                      setChats(prevChats => {
                        return prevChats.map(chat => {
                          if (chat.id === chatId) {
                            const updatedChat = {
                              ...chat,
                              user: {
                                ...chat.user,
                                lastMessage: message,
                                lastMessageTime: new Date().toLocaleDateString(),
                                messages: [...chat.user.messages, newMessage]
                              }
                            };
                            console.log('Updated chat:', updatedChat);
                            return updatedChat;
                          }
                          return chat;
                        });
                      });

                      // Update filtered chats and selected chat
                      setFilteredChats(prevFiltered => {
                        return prevFiltered.map(chat => {
                          if (chat.id === chatId) {
                            const updatedChat = {
                              ...chat,
                              user: {
                                ...chat.user,
                                lastMessage: message,
                                lastMessageTime: new Date().toLocaleDateString(),
                                messages: [...chat.user.messages, newMessage]
                              }
                            };
                            // Also update selected chat if this is the current chat
                            if (selectedChat && selectedChat.id === chatId) {
                              console.log('Updating selected chat:', updatedChat);
                              setSelectedChat(updatedChat);
                            }
                            return updatedChat;
                          }
                          return chat;
                        });
                      });

                      // Mark messages as read
                      await api.put(`/chat/${chatId}/read`);

                    } catch (error) {
                      console.error('Error sending message:', error);
                      alert('Failed to send message. Please try again.');
                    }
                  };

                  const handleSendRequest = async (userId) => {
                    try {
                      const response = await api.post(`/friends/send-request/${userId}`);
                      alert('Friend request sent successfully!');
                      await fetchInitialData(); // Refresh the data
                    } catch (error) {
                      console.error('Error sending friend request:', error);
                      alert(error.response?.data?.message || 'Error sending friend request');
                    }
                  };

                  // Get filtered users for search results
                  const getFilteredUsers = () => {
                    if (!searchQuery) return [];
                    
                    const currentUser = JSON.parse(localStorage.getItem('user'));
                    const searchLower = searchQuery.toLowerCase();
                    
                    return users.filter(user => {
                      // Don't show current user
                      if (user._id === currentUser?._id) return false;
                      
                      // Check if name matches search
                      const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();
                      const isMatch = fullName.includes(searchLower) || 
                                    user.email.toLowerCase().includes(searchLower);
                      
                      // Check if already in chat list
                      const isInChat = chats.some(chat => chat.user.id === user._id);
                      
                      return isMatch && !isInChat;
                    });
                  };

                  const handleChatSelect = (chat, index) => {
                    setSelectedChat(chat);
                    setIsActive(index);
                  };

                  return (
                    <Stack>
                      <Typography variant="h6" sx={{ mb: 2 }}>Messages</Typography>
                      
                      {/* Search Bar */}
                      <TextField
                        fullWidth
                        placeholder="Search messages or users..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        sx={{
                          mb: 2,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                            backgroundColor: '#F8F8F8',
                            '&:hover': {
                              backgroundColor: '#F0F0F0',
                            },
                          }
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                      />

                      {/* Search Results */}
                      {showSearchResults && searchQuery && (
                        <Stack
                          sx={{
                            position: 'absolute',
                            top: '120px',
                            left: '20px',
                            right: '20px',
                            bgcolor: 'white',
                            borderRadius: '12px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                            zIndex: 1000,
                            maxHeight: '400px',
                            overflowY: 'auto',
                            p: 2,
                          }}
                        >
                          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                            Search Results
                          </Typography>
                          {getFilteredUsers().map((user) => (
                            <ListItem
                              key={user._id}
                              sx={{
                                borderRadius: '8px',
                                mb: 1,
                                '&:hover': { bgcolor: '#F8F8F8' },
                              }}
                            >
                              <ListItemAvatar>
                                <Avatar src={user.profileImage || "/images/default-avatar.jpeg"} />
                              </ListItemAvatar>
                              <ListItemText
                                primary={`${user.firstName} ${user.lastName}`}
                                secondary={user.email}
                              />
                              <Stack direction="row" spacing={1}>
                                {friends.some(friend => friend._id === user._id) ? (
                                  <Button
                                    startIcon={<MessageIcon />}
                                    variant="contained"
                                    size="small"
                                    onClick={() => handleStartChat(user._id)}
                                    sx={{ borderRadius: '20px' }}
                                  >
                                    Message
                                  </Button>
                                ) : (
                                  <Button
                                    startIcon={<AddIcon />}
                                    variant="outlined"
                                    size="small"
                                    onClick={() => handleSendRequest(user._id)}
                                    sx={{ borderRadius: '20px' }}
                                  >
                                    Add Friend
                                  </Button>
                                )}
                              </Stack>
                            </ListItem>
                          ))}
                        </Stack>
                      )}

                      <Divider
                        sx={{
                          height: "1px",
                          bgcolor: "#EBEBEB",
                          mx: "-20px",
                          my: "16px",
                          border: "none",
                        }}
                      />

                      <Stack id="main" direction="row" spacing={1.2}>
                        {/* Chats List */}
                        <Stack id="chats-container" spacing={1.2}>
                          {filteredChats.map((chat, i) => (
                            <Stack
                              component="button"
                              key={chat.id}
                              id="chats"
                              sx={{
                                width: "426px",
                                bgcolor: i === isActive ? "#F8F8F8" : "#ffffff",
                                borderRadius: "12px",
                                p: "12px",
                                px: "14px",
                                border: "1px solid #E3E3E3",
                                cursor: "pointer",
                              }}
                              spacing={1.5}
                              onClick={() => handleChatSelect(chat, i)}
                            >
                              <MessagesProfileComponent
                                primaryText={chat.user.name}
                                secondaryText={chat.user.lastMessage}
                                time={chat.user.lastMessageTime}
                              />
                            </Stack>
                          ))}
                        </Stack>

                        {/* Chat Messages */}
                        <Stack
                          id="chat-description"
                          sx={{
                            border: "1px solid #E3E3E3",
                            width: "68%",
                            bgcolor: "#F8F8F8",
                            py: "12px",
                            px: "22px",
                            borderRadius: "16px",
                            height: "max-content",
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          {selectedChat ? (
                            <>
                              <MessagesProfileComponent
                                primaryText={selectedChat.user.name}
                                secondaryText="Online"
                                chatDescriptionHeading={true}
                                chatConservation={true}
                              />
                              <Divider
                                sx={{
                                  height: "1px",
                                  bgcolor: "#EBEBEB",
                                  mx: "-20px",
                                  my: "16px",
                                  border: "none",
                                }}
                              />
                              <Stack
                                sx={{
                                  maxHeight: '500px',
                                  overflowY: 'auto',
                                  p: 2,
                                  gap: 1
                                }}
                              >
                                {selectedChat?.user?.messages?.map((message, index) => (
                                  <MessagesProfileComponent
                                    key={index}
                                    primaryText={message.time}
                                    secondaryText={message.text}
                                    chatConservation={true}
                                    isMyMessage={message.sender === 'me'}
                                    avatar={message.sender === 'me' ? currentUser?.profileImage : selectedChat.user.avatar}
                                  />
                                ))}
                              </Stack>
                              
                              {/* Message Input */}
                              <Stack 
                                direction="row" 
                                spacing={1} 
                                sx={{ 
                                  mt: 'auto',
                                  borderTop: '1px solid #EBEBEB',
                                  pt: 2
                                }}
                              >
                                <TextField
                                  fullWidth
                                  placeholder="Type a message..."
                                  size="small"
                                  onKeyPress={(e) => {
                                    if (e.key === 'Enter' && e.target.value.trim()) {
                                      handleSendMessage(selectedChat.id, e.target.value.trim());
                                      e.target.value = '';
                                    }
                                  }}
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '20px',
                                      backgroundColor: '#FFFFFF',
                                    }
                                  }}
                                />
                                <Button 
                                  variant="contained"
                                  onClick={() => {
                                    const input = document.querySelector('input[placeholder="Type a message..."]');
                                    if (input && input.value.trim()) {
                                      handleSendMessage(selectedChat.id, input.value.trim());
                                      input.value = '';
                                    }
                                  }}
                                  sx={{ 
                                    borderRadius: '20px',
                                    minWidth: '100px'
                                  }}
                                >
                                  Send
                                </Button>
                              </Stack>
                            </>
                          ) : (
                            <Typography variant="body1" sx={{ textAlign: 'center', py: 3 }}>
                              Select a chat to view messages
                            </Typography>
                          )}
                        </Stack>
                      </Stack>
                    </Stack>
                  );
                }

                export default MessagesSection;
